module.exports = __webpack_public_path__ + "static/learning-ef11a5cbb58b28151e23971a4fdc9002.jpg";